var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"min-h-screen w-full bg-light-800 dark:bg-dark-900"},[_c('dark-toggle',{staticClass:"absolute top-4 right-4"}),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }